import { gql, TypedDocumentNode } from '@common/hooks';
import {
  CancelShiftGapMutationCgResponse,
  CancelShiftGapMutationVariables,
  CreateShiftGapMutationCgResponse,
  CreateShiftGapMutationVariables,
  UpdateShiftGapMutationCgResponse,
  UpdateShiftGapMutationVariables,
  UpdateShiftGapTagMutationCgResponse,
  UpdateShiftGapTagMutationVariables,
  UpsertWorkforceGroupShiftGapOverridesMutationCgResponse,
  UpsertWorkforceGroupShiftGapOverridesMutationVariables,
} from '@common/graphql/schema';

export const CREATE_SHIFT_MUTATION: TypedDocumentNode<
  CreateShiftGapMutationCgResponse,
  CreateShiftGapMutationVariables
> = gql`
  mutation CreateShiftGap($input: CreateShiftGapInput!) {
    createShiftGap(input: $input) {
      shiftGap {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const UPDATE_SHIFT_MUTATION: TypedDocumentNode<
  UpdateShiftGapMutationCgResponse,
  UpdateShiftGapMutationVariables
> = gql`
  mutation UpdateShiftGap($input: UpdateShiftGapInput!, $id: ID!) {
    updateShiftGap(input: $input, id: $id) {
      shiftGap {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const UPDATE_SHIFT_TAG_MUTATION: TypedDocumentNode<
  UpdateShiftGapTagMutationCgResponse,
  UpdateShiftGapTagMutationVariables
> = gql`
  mutation UpdateShiftGapTag($id: ID!, $input: UpdateShiftGapTagInput!) {
    updateShiftGapTag(input: $input, id: $id) {
      shiftGap {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const CANCEL_SHIFT_MUTATION: TypedDocumentNode<
  CancelShiftGapMutationCgResponse,
  CancelShiftGapMutationVariables
> = gql`
  mutation CancelShiftGap($id: ID!) {
    cancelShiftGap(id: $id) {
      shiftGap {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;

export const UPSERT_WORKFORCE_GROUP_SHIFT_GAP_OVERRIDES: TypedDocumentNode<
  UpsertWorkforceGroupShiftGapOverridesMutationCgResponse,
  UpsertWorkforceGroupShiftGapOverridesMutationVariables
> = gql`
  mutation UpsertWorkforceGroupShiftGapOverrides(
    $input: [UpsertWorkforceGroupShiftGapOverridesInput!]!
    $shiftGapId: ID!
  ) {
    upsertWorkforceGroupShiftGapOverrides(
      input: $input
      shiftGapId: $shiftGapId
    ) {
      shiftGap {
        id
      }
      errors {
        attribute
        humanAttribute
        errors
        fullErrors
      }
    }
  }
`;
